import { createReducer, on } from '@ngrx/store';
import paymentsActions from './payments.actions';
import { ApiState } from '../../model/api-state.model';
import { PaymentsPolicyResponse, PaymentsTransactionResponse } from '../../model/payments.model';
import AppError from '../../model/app-error';

export { paymentsActions as actions };

export * from './payments.selectors';

export interface State {
  transactionState: ApiState;
  transactionData: PaymentsTransactionResponse | null;
  transactionError: AppError | null;
  transactionStatePrev: ApiState;
  transactionDataPrev: PaymentsTransactionResponse | null;
  transactionErrorPrev: AppError | null;
  policyState: ApiState;
  policyData: PaymentsPolicyResponse | null;
  policyError: AppError | null;
}

export const initialState: State = {
  transactionState: ApiState.idle,
  transactionData: null,
  transactionError: null,
  transactionStatePrev: ApiState.idle,
  transactionDataPrev: null,
  transactionErrorPrev: null,
  policyState: ApiState.idle,
  policyData: null,
  policyError: null,
};

export const reducer = createReducer(
  initialState,
  on(paymentsActions.reset, () => initialState),
  on(paymentsActions.resetOnInit, (state) => ({
    ...state,
    transactionState: initialState.transactionState,
    transactionData: initialState.transactionData,
    transactionStatePrev: initialState.transactionStatePrev,
    transactionDataPrev: initialState.transactionDataPrev,
  })),
  on(paymentsActions.resetOnStatus, (state) => ({
    ...state,
    policyState: initialState.policyState,
    policyData: initialState.policyData,
  })),
  on(paymentsActions.fetchTransactionStart, (state) => ({
    ...state,
    transactionState: ApiState.pending,
    transactionData: null,
    transactionError: null,
    transactionStatePrev: state.transactionState,
    transactionDataPrev: state.transactionData,
    transactionErrorPrev: state.transactionError,
  })),
  on(paymentsActions.fetchTransactionSuccess, (state, { success }) => ({
    ...state,
    transactionState: ApiState.success,
    transactionData: success,
    transactionError: null,
  })),
  on(paymentsActions.fetchTransactionError, (state, { error }) => ({
    ...state,
    transactionState: ApiState.error,
    transactionData: null,
    transactionError: error,
  })),
  on(paymentsActions.fetchPolicyStart, (state) => ({ ...state, policyState: ApiState.pending, policyData: null, policyError: null })),
  on(paymentsActions.fetchPolicySuccess, (state, { success }) => ({
    ...state,
    policyState: ApiState.success,
    policyData: success,
    policyError: null,
  })),
  on(paymentsActions.fetchPolicyError, (state, { error }) => ({
    ...state,
    policyState: ApiState.error,
    policyData: null,
    policyError: error,
  })),
);
